var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isProlific)?_c('prolific-entry'):_c('login')
}
var staticRenderFns = []

export { render, staticRenderFns }